import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLocation } from '@grandvisionhq/locations';
import { getStoreDetailUrl } from '../../utils/store-utils.js';
import 'lodash/deburr';
import { StoreFinderContext } from './context.js';

const StoreFinderProvider = ({ children , googleMapsId , hidePhone =false , hideEmail =false , withUrlParams =false , storeFilter =()=>true
 , initialStores , sku , events , searchQuery: initialSearchQuery , urls ,  })=>{
    const [stores, setStores] = React.useState(initialStores || []);
    const [hoveredStore, setHoveredStore] = React.useState(null);
    const [isStoresLoading, setIsStoresLoading] = React.useState(false);
    const [searchQuery, setSearchQuery] = React.useState(initialSearchQuery !== null && initialSearchQuery !== void 0 ? initialSearchQuery : '');
    const [isPristineSearch, setIsPristineSearch] = React.useState(initialStores ? false : true);
    const [suggestions, setSuggestions] = React.useState([]);
    const [selectedLocation, setSelectedLocation] = React.useState('');
    const [preferredStore, setPreferredStore] = React.useState(null);
    const [activeMapInfoWindow, setActiveMapInfoWindow] = React.useState(null);
    const [appliedStoreFilters, setAppliedStoreFilters] = React.useState({});
    const { position: userLocation , isPositionLoading: isUserLocationLoading , isUseMyLocation: isUsingUserLocation , isMyLocationRequested: isUserLocationRequested , setIsMyLocationRequested: setIsUserLocationRequested , error: useUserLocationError ,  } = useLocation(false, {
        enableHighAccuracy: true,
        timeout: 10 * 1000,
        maximumAge: 0
    });
    const clearSearch = React.useCallback(()=>{
        setSearchQuery('');
        setSelectedLocation('');
        setSuggestions([]);
        setIsUserLocationRequested(false);
        setActiveMapInfoWindow(null);
    }, [
        setSearchQuery,
        setSelectedLocation,
        setSuggestions,
        setIsUserLocationRequested,
        setActiveMapInfoWindow, 
    ]);
    const getStoreDetailsUrl = React.useCallback((store)=>{
        if (!(urls === null || urls === void 0 ? void 0 : urls.storeDetails)) {
            console.warn("getStoreDetailsUrl will not return a url because you didn't specify the localized storeDetails url");
            return '';
        }
        const storeDetailsUrlProvider = getStoreDetailUrl(urls.storeDetails);
        return storeDetailsUrlProvider(store);
    }, [
        urls === null || urls === void 0 ? void 0 : urls.storeDetails
    ]);
    const appliedStoreFilterCount = Object.entries(appliedStoreFilters).reduce((total, [, appliedOptions])=>appliedOptions.length > 0 ? total + appliedOptions.length : total
    , 0);
    const toggleAppliedStoreFilter = React.useCallback((filterName, optionName)=>{
        var _filterName;
        const existingFilterOptions = (_filterName = appliedStoreFilters[filterName]) !== null && _filterName !== void 0 ? _filterName : [];
        const isFilterAlreadyEnabled = existingFilterOptions.includes(optionName);
        setAppliedStoreFilters(swcHelpers.objectSpread({}, appliedStoreFilters, {
            [filterName]: isFilterAlreadyEnabled ? existingFilterOptions.filter((option)=>option !== optionName
            ) : [
                ...existingFilterOptions,
                optionName
            ]
        }));
    }, [
        appliedStoreFilters
    ]);
    const clearAppliedStoreFilters = ()=>{
        setAppliedStoreFilters({});
    };
    const config = React.useMemo(()=>({
            googleMapsId,
            hidePhone,
            hideEmail,
            withUrlParams,
            storeFilter
        })
    , [
        googleMapsId,
        hidePhone,
        hideEmail,
        withUrlParams,
        storeFilter
    ]);
    const values = React.useMemo(()=>({
            config,
            stores,
            hoveredStore,
            activeMapInfoWindow,
            setActiveMapInfoWindow,
            isLocationSelected: selectedLocation.length > 0,
            searchQuery: selectedLocation.length > 0 ? selectedLocation : searchQuery,
            isStoresLoading,
            isPristineSearch,
            suggestions,
            userLocation,
            isUsingUserLocation,
            useUserLocationError,
            isUserLocationRequested,
            setIsUserLocationRequested,
            isUserLocationLoading,
            clearSearch,
            getStoreDetailsUrl,
            setSelectedLocation,
            selectedLocation,
            setSuggestions,
            setIsPristineSearch,
            setSearchQuery,
            setStores,
            setHoveredStore,
            setIsStoresLoading,
            sku,
            events,
            preferredStore,
            setPreferredStore,
            urls,
            appliedStoreFilters,
            appliedStoreFilterCount,
            toggleAppliedStoreFilter,
            clearAppliedStoreFilters
        })
    , [
        config,
        stores,
        hoveredStore,
        activeMapInfoWindow,
        selectedLocation,
        searchQuery,
        isStoresLoading,
        isPristineSearch,
        suggestions,
        userLocation,
        isUsingUserLocation,
        useUserLocationError,
        isUserLocationRequested,
        setIsUserLocationRequested,
        isUserLocationLoading,
        clearSearch,
        getStoreDetailsUrl,
        sku,
        events,
        preferredStore,
        urls,
        appliedStoreFilters,
        appliedStoreFilterCount,
        toggleAppliedStoreFilter, 
    ]);
    return /*#__PURE__*/ React.createElement(StoreFinderContext.Provider, {
        value: values
    }, children);
};

export { StoreFinderProvider };
//# sourceMappingURL=provider.js.map
